import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getPlatformAnnouncement } from "../../../services/admin/admin-platform-service";
import { primaryColor } from "../../shared/styles/color";

export function PlatformAnnouncementBanner() {
  const [announcement, setAnnouncement] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await getPlatformAnnouncement();
        if (!cancelled && res?.status === 200) {
          setAnnouncement(res.data?.result?.data || null);
        }
      } catch {
        /* ignore */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (dismissed || !announcement?.enabled) return null;

  return (
    <Banner role="status">
      <div>
        {announcement.title ? <strong>{announcement.title}</strong> : null}
        {announcement.body ? <span>{announcement.body}</span> : null}
      </div>
      <DismissBtn type="button" onClick={() => setDismissed(true)} aria-label="Dismiss">
        ×
      </DismissBtn>
    </Banner>
  );
}

const Banner = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 16px;
  background: #ecfeff;
  border-bottom: 1px solid #a5f3fc;
  color: #0f172a;
  font-size: 14px;
  line-height: 1.45;

  strong {
    display: block;
    margin-bottom: 2px;
    color: ${primaryColor};
  }
`;

const DismissBtn = styled.button`
  border: 0;
  background: transparent;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  color: #64748b;
  padding: 0 4px;
`;
